// export enum Gender {
//     Male = 1,
//     Female = -1
// }

export enum Gender {
    Male = 1,
    Female = -1
}